import { Base } from '@studiometa/js-toolkit';

/**
 * StickyBar
 */
export default class ProductStickyBar extends Base {
  static config = {
    name: 'ProductStickyBar',
  };

  isVisible = false;

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @returns {void}
   */
  scrolled({ y }) {
    if (y === 0) {
      this.$el.classList.add('translate-y-full');
      this.isVisible = false;
      return;
    }

    if (!this.isVisible && y >= 0) {
      this.isVisible = true;
      this.$el.classList.remove('translate-y-full');
    }
  }
}
